/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_N1Inputs */

const en_diff_ref_n1 = /** @type {(inputs: Diff_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The path exists only on the right. The value shown is the new one.`)
};

const ko_diff_ref_n1 = /** @type {(inputs: Diff_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경로가 오른쪽에만 있습니다. 표시된 값이 새 값입니다.`)
};

const ja_diff_ref_n1 = /** @type {(inputs: Diff_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスが右側にだけあります。表示されている値が新しい値です。`)
};

/**
* | output |
* | --- |
* | "The path exists only on the right. The value shown is the new one." |
*
* @param {Diff_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_n1 = /** @type {((inputs?: Diff_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_n1(inputs)
	if (locale === "ko") return ko_diff_ref_n1(inputs)
	return ja_diff_ref_n1(inputs)
});